import { render, staticRenderFns } from "./formsTextArea.vue?vue&type=template&id=de61ac2e&"
import script from "./formsTextArea.vue?vue&type=script&lang=js&"
export * from "./formsTextArea.vue?vue&type=script&lang=js&"
import style0 from "./formsTextArea.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports